<youtube-player-modal>
  <div class="modal" tab-index="-1">
    <div aria-label="Close" data-dismiss="modal" class="modal-dismiss close" onclick={ closeModal }></div>
    <div class="modal-wrapper">
      <iframe
        class="video-youtube"
        id="youtube-video-modal-block-content"
        data-youtube={ props.youtubeVideoId }
        frameborder="0"
        allowfullscreen="1"
        allowscriptaccess="always"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        title="YouTube video player"
        width="600"
        height="400"
        data-sdi="true"
      ></iframe>
    </div>
  </div>
  
  <script type="ts">
    import {RiotComponentExport} from 'riot';

    interface Props {
      youtubeVideoId: string;
    }
    
    function build(): RiotComponentExport<Props, never> {
      return {
        
        openModal(e: PointerEvent) {
          e.preventDefault();
          
          const modal = document.querySelector('.modal') as HTMLDivElement;
          
          if (modal !== null && modal.classList.contains('show') === false) {
            modal.classList.add('show');
            document.body.style.position = 'sticky';
            document.body.style.height = '100%';
            document.body.style.overflow = 'hidden';
            
            const iframe = document.querySelector('.video-youtube') as HTMLIFrameElement;
            const buttonTarget = (e.currentTarget) as HTMLElement;
            const ytId = buttonTarget.dataset.youtubevideoid as string;
            
            if (iframe !== null) {
              iframe.setAttribute('src', `https://www.youtube.com/embed/${ytId}?rel=0&enablejsapi=1&origin=https://www.deere.com&version=3&playerapiid=ytplayer`);
              iframe.setAttribute('data-youtube', ytId);
            }
          }
        },
        
        closeModal() {
          const modal = document.querySelector('.modal') as HTMLDivElement;
          
          if (modal !== null && modal.classList.contains('show') === true) {
            modal.classList.remove('show');
            document.body.style.position = '';
            document.body.style.height = '';
            document.body.style.overflow = '';
            
            const iframe = document.querySelector('.video-youtube') as HTMLIFrameElement;
            
            if (iframe !== null) {
              iframe.setAttribute('src', '');
            }
          }
        },
        
        onMounted(): void {
          this.setListeners();
        },
        
        onBeforeUnmount(): void {
          this.removeListeners();
        },
        
        setListeners(): void {
          const playerModals = Array.from(document.querySelectorAll('.youtube-player-modal'));
          playerModals.forEach( el => {
            el.addEventListener('click', this.openModal);
          });
        },
        
        removeListeners(): void {
          const playerModals = Array.from(document.querySelectorAll('.youtube-player-modal'));
          playerModals.forEach( el => {
            el.removeEventListener('click', this.openModal);
          });
        }
      };
    }
    
    build.components = {
    };
    
    export default build;
  </script>
  
  <style type="scss">
    @use './src/client/sass/abstracts/colors';
    @use './src/client/sass/abstracts/fonts';
    @use './src/client/sass/abstracts/respond';
    
    #youtube-player-modal {
      cursor: pointer;
    }
    
    .modal {
      display: none;
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background-color: rgba( 0, 0, 0, 0.85);
      
      &.show {
        display: block;
      }
      
      .modal-dismiss {
        color: #333333;
        background-color: #FDDA01;
        padding: 10px;
        font-size: 12px;
        position: fixed;
        top: 5%;
        right: 0;
        opacity: 1;
        font-weight: bold;
        
        &::before {
          content: 'X';
        }
      }
      
      .modal-wrapper {
        position: relative;
        padding-bottom: 56.25%!important;
        height: 0;
        width: 85%;
        margin: 0 auto;
        display: block;
        top: 5%;
        
        iframe {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      }
    }
  </style>
</youtube-player-modal>